module.exports = import("https://cdn.sheetjs.com/xlsx-0.20.1/package/xlsx.mjs");;